module.exports = __webpack_public_path__ + "img/cross.6dbb7e59.svg";